import {GET_TRANSMISSION } from "../actions/types";

const initialState=[]

export default function transmissions(state = initialState, action) {
    switch (action.type) {
      case GET_TRANSMISSION:
        return action.payload;
      default:
        return state;
    }
  }